module.exports = __webpack_public_path__ + "static/people_img15-d0bc2fe3abf218ae228d507e010ae139.png";